const filtersLookupsReporting = [
  { id: 'ALL', name: 'All Contacts' },
  { id: 'ADMIN', name: 'Admin Contacts' },
  { id: 'NON_ADMIN', name: 'Non-Admin Contacts' },
  { id: 'NO_NOTIFICATION', name: 'No Notifications set' }
];

const filtersLookupsEmail = [
  { id: 'ALL', name: 'All Contacts' },
  { id: 'ADMIN', name: 'Admin Contacts' },
  { id: 'NON_ADMIN', name: 'Non-Admin Contacts' }
];

export { filtersLookupsReporting, filtersLookupsEmail };
